import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { EntityDataDispatcher } from '../entity-data/entity-data.dispatcher';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './expense-data.reducer';
import { ExpenseDataBuilder } from './expense-data.builder';
import { ExpenseDataStore } from './expense-data.store';
import { Expense } from './models/expense.model';

@Injectable()
export class ExpenseDataDispatcher extends EntityDataDispatcher<
  IState,
  Expense
> {
  constructor(
    store: Store<any>,
    expenseDataStore: ExpenseDataStore,
    expenseDataBuilder: ExpenseDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      expenseDataStore,
      expenseDataBuilder,
      globalBannerService,
      translateService
    );
  }
}
